var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"genericHeader"},[_c('div',{staticClass:"logo genericHeader__logo",attrs:{"role":"img","aria-label":"TriviaPop"}})])}]

export { render, staticRenderFns }